export default __webpack_public_path__ + "static/media/keycard-swisspass-back@4x.aef479e0.png";